import { Link } from "react-router-dom";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import CompareViewModel from "../viewModel";
import { getMultiLangProperty } from "../../../helpers/generalHelper";

const Product = () => {
  const { t, i18n } = useTranslation();
  const { compareItems, deleteFromCompare } = useContext(
    CompareViewModel.Context
  );

  return (
    <tr>
      <th className="title-column">{t("compare.product")}</th>
      {compareItems.map((compareItem) => (
        <td className="product-image-title" key={compareItem._id}>
          <div className="compare-remove">
            <button
              type="button"
              onClick={() => deleteFromCompare(compareItem)}
            >
              <i className="pe-7s-trash" />
            </button>
          </div>
          <Link
            to={`${process.env.PUBLIC_URL}/product/${compareItem._id}`}
            className="image"
          >
            <img
              className="img-fluid"
              src={
                Array.isArray(compareItem.media) &&
                compareItem.media.length >= 1
                  ? compareItem.media[0].fileUrl
                  : ""
              }
              alt=""
              style={{ height: 200, width: 200, objectFit: "contain" }}
            />
          </Link>
          <div className="product-title">
            <Link to={`${process.env.PUBLIC_URL}/product/${compareItem._id}`}>
              {getMultiLangProperty(compareItem.name, i18n.language)}
            </Link>
          </div>
          <div className="compare-btn">
            <Link to={`${process.env.PUBLIC_URL}/product/${compareItem._id}`}>
              {t("compare.view")}
            </Link>
          </div>
        </td>
      ))}
    </tr>
  );
};

export default Product;
